/*
  src/redux/entities/actions.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import {
  NO_OP,
  LIST_REQUESTED,
  LIST_LOADED,
  LIST_FAILED_TO_LOAD,
  ENTITY_UPDATE_REQUESTED,
  ENTITY_UPDATED,
  ENTITY_PUBLISHERS_UPDATE_REQUESTED,
  ENTITY_PUBLISHERS_UPDATED,
  ENTITY_FAILED_TO_UPDATE,
  ENTITY_REQUESTED,
  ENTITY_LOADED,
  ACTIVE_USER_LOADED,
  IMPERSONATED_USER_LOADED,
  ENTITY_FAILED_TO_LOAD,
  ENTITY_CREATE_REQUESTED,
  ENTITY_CREATED,
  ENTITY_FAILED_TO_CREATE,
  REDEMPTION_REQUESTED,
  REDEPTION_COMPLETED,
  REDEMPTION_FAILED,
  ENTITY_DELETE_REQUESTED,
  ENTITY_DELETED,
  ENTITY_FAILED_TO_DELETE,
  ENTITY_EXISTS,
  ENGAGEMENT_OPTION_CREATE_REQUESTED,
  ENGAGEMENT_OPTION_CREATED,
  ENGAGEMENT_OPTION_FAILED_TO_CREATE,
  ENGAGEMENT_OPTION_DELETE_REQUESTED,
  ENGAGEMENT_OPTION_DELETED,
  ENGAGEMENT_OPTION_FAILED_TO_DELETE,
  ENGAGEMENT_OPTION_UPDATE_REQUESTED,
  ENGAGEMENT_OPTION_UPDATED,
  ENGAGEMENT_OPTION_FAILED_TO_UPDATE,
  ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED,
  ENGAGEMENT_SORT_ORDER_UPDATED,
  ENGAGEMENT_SORT_ORDER_UPDATE_FAILED,
  ENGAGEMENT_OPTIONS_UPDATE_REQUESTED,
  ENGAGEMENT_OPTIONS_UPDATED,
  ENGAGEMENT_OPTIONS_FAILED_TO_UPDATE,
  LOYALTY_BALANCE_REQUESTED,
  LOYALTY_BALANCE_LOADED,
  LOYALTY_BALANCE_FAILED_TO_LOAD,
  LOYALTY_BALANCE_ADJUSTMENT_REQUESTED,
  LOYALTY_BALANCE_ADJUSTED,
  LOYALTY_BALANCE_ADJUSTMENT_FAILED,
  SET_APPROVED_RETAILERS_REQUESTED,
  APPROVED_RETAILERS_SET,
  SET_APPROVED_RETAILERS_FAILED,
  ENTITY_DUPLICATE_REQUESTED,
  ENTITY_DUPLICATED,
  ENTITY_FAILED_TO_DUPLICATE,
  ENTITY_EXTEND_REQUESTED,
  ENTITY_EXTENDED,
  ENTITY_FAILED_TO_EXTEND,
  ENTITY_BATCH_REQUESTED,
  ENTITY_BATCH_LOADED,
  ENTITY_BATCH_FAILED_TO_LOAD,
  ENTITY_VALIDATION_REQUESTED,
  ENTITY_VALIDATED,
  ENTITY_FAILED_TO_VALIDATE,
  ENTITY_TAGS_SYNC_REQUESTED,
  ENTITY_TAGS_SYNCED,
  ENTITY_TAGS_SYNC_FAILED,
  ENTITY_HISTORY_REQUESTED,
  ENTITY_HISTORY_LOADED,
  ENTITY_HISTORY_FAILED_TO_LOAD,
  ENTITY_GEOFILTER_SYNC_REQUESTED,
  ENTITY_GEOFILTER_SYNCED,
  ENTITY_GEOFILTER_SYNC_FAILED,
  ENTITY_CONSTRAINTS_SYNC_REQUESTED,
  ENTITY_CONSTRAINTS_SYNCED,
  ENTITY_CONSTRAINTS_SYNC_FAILED
} from './constants';

// import {
//   TOKEN_LOADED as IMPERSONATE_TOKEN_LOADED
// } from '../impersonate/actions';

import callAPI from '../callAPI';
import {
  getActiveAgencyUser,
  getIsImpersonating
} from '../selectors';
import { generateGUID } from '../../../shared/utils';
import {
  marshalAgency,
  marshalCampaign,
  marshalCompany,
  marshalUser,
  marshalPaymentMethod,
  marshalTag
} from '../marshallers'
/*
  LOAD PAGE ACTIONS
*/
function createLoadAction(collection,pagePath,impersonate=false){
  return function(page=0,size=100000){
    const path = pagePath ? pagePath : `/portal/v1/${collection}/list`;

    return callAPI({
      path:`${path}?page=${page}&size=${size}`,
      begin:{
        type:LIST_REQUESTED,
        payload:() => ({ collection:collection })
      },
      success:{
        type:LIST_LOADED,
        payload:(res) => ({
          collection:collection,
          instances: res.data ? res.data : res,
          hasNextPage:res.page ? res.page.totalPages > page + 1 : false,
          hasPreviousPage:page > 0
        })
      },
      failure:{
        type:LIST_FAILED_TO_LOAD
      }
    });
  }
}

//LISTS
export const loadAgencies = createLoadAction('agencies','/portal/v1/agency/list');
export const loadBrands = createLoadAction('companies','/portal/v1/brand/list');
export const loadRetailers = createLoadAction('companies','/portal/v1/retailer/list');
export const loadProviders = createLoadAction('users','/portal/v1/provider/list');
export const loadPrograms = createLoadAction('programs','/portal/v1/program/list');
export const loadReceiptLineups = createLoadAction('receiptLineups','/portal/v1/rscan/lineup/list');
export const loadPromotions = createLoadAction('promotions','/portal/v1/brand/promo/list');
export const loadAffiliates = createLoadAction('affiliates','/portal/v1/affiliate/list');
export const loadMilestones = createLoadAction('milestones','/portal/v1/milestone/list');
export const loadRewardPromos = createLoadAction('promos','/portal/v1/promo/list');
export const loadUsers = createLoadAction('users','/portal/v1/user/list');
export const loadPendingUsers = createLoadAction('users','/portal/v1/user/invited');
export const loadAppUsers = createLoadAction('appUsers','/portal/v1/appUser/list');
export function loadCampaigns(excludePadlockCampaigns) {
  return callAPI({
    path: `/portal/v1/campaign/list?excludePadlockCampaigns=${excludePadlockCampaigns}`,
    begin: {
      type: LIST_REQUESTED,
      payload: () => ({collection: 'campaigns'})
    },
    success: {
      type: LIST_LOADED,
      payload: (res) => ({
        collection: 'campaigns',
        instances: res.data,
        hasNextPage: false,
        hasPreviousPage: false
      })
    },
    failure: {
      type: LIST_FAILED_TO_LOAD
    }
  });
}
export const loadArchivedCampaigns = createLoadAction('campaigns','/portal/v1/campaign/archived/list');
export const loadSegments = createLoadAction('segmentations','/portal/v1/segmentation/list');
export const loadPromoCodes = createLoadAction('promoCodes','/portal/v1/promoCode/list');
export const loadTagVendors = createLoadAction('tagVendors','/portal/v1/tagVendor/list');
export const loadGiftCards= createLoadAction('giftcards','/portal/v1/giftCard/list');

//AGENCY SUB LISTS
export const loadBrandsForAgency = (id,page=0,size=100) => createLoadAction('companies',`/portal/v1/agency/${id}/brands`)(page,size);
export const loadCampaignsForAgency = (id,page=0,size=100) => createLoadAction('campaigns',`/portal/v1/agency/${id}/campaigns`)(page,size);
export const loadUsersForAgency = (id,page=0,size=100) => createLoadAction('users',`/portal/v1/agency/${id}/users`)(page,size);
export const loadEngagementsForCampaign = (id,page=0,size=100) => createLoadAction('engagements',`/portal/v1/campaign/${id}/engagements`)(page,size);
export const loadPaymentMethodsForAgency = (agencyId,page=0,size=100) => createLoadAction('paymentMethods',`/portal/v1/payment/${agencyId}/token/list`)(page,size);
export const loadProgramsForAgency = (id,page=0,size=100) => createLoadAction('programs',`/portal/v1/agency/${id}/programs`)(page,size);
// export function loadProgramsForAgency(id){
//   return loadPrograms()
// }

// export function loadProgramsForAgency(id,page=0,size=100){
//   console.log("loadProgramsForAgency: start")
//   return callAPI({
//     impersonate:false,
//     path:`/portal/v1/retailer/list?page=${page}&size=${size}`,
//     begin:{
//       type:LIST_REQUESTED,
//       payload:() => ({ collection:'programs' })
//     },
//     success:{
//       type:LIST_LOADED,
//       payload:(res) => ({
//         collection:'programs',
//         instances: [{"id": "7969b2fb-ffa0-4853-9efc-ddc038fe8158", "name": "Test Program", "budget": 500.00, "status": "active", "endDate": "2020-05-27T03:55:17.538958", "logoUrl": "https://storage.googleapis.com/adjoy-app-assets/static/wallmart_logo.png", "agencyId": "da1e6624-9fb4-4553-8c37-6341a98a28dd", "cardText": "card", "feedText": "feed text that contains more words for test purposes, win win", "scanText": "scan", "endedText": "ended", "startDate": "2020-05-07T03:55:17.538958", "cardAmount": 1.00, "giftCardId": "7cb09913-c878-4e35-a743-01c4f90f80eb", "createdDate": "2020-05-07T03:55:17.538958", "displayDate": "2020-06-16T03:55:17.538958", "backgroundColor": "#2233dd", "lastModifiedDate": "2020-05-07T03:55:17.538958"}],
//         hasNextPage:false,
//         hasPreviousPage:false
//       })
//     },
//     failure:{
//       type:LIST_FAILED_TO_LOAD
//     }
//   })
// }

/*
  STATUS ACTIONS
*/
function createStatusAction(collection,entityPath,update,updated){
  return function(id){
    return callAPI({
      method:'POST',
      path:`${entityPath}/${id}/${update}`,
      body:{},
      begin:{
        type:ENTITY_UPDATE_REQUESTED,
        payload:() => ({
          collection:collection,
          instance:id,
          update:{
            status:updated
          }
        })
      },
      success:{
        type:ENTITY_UPDATED,
        payload:(res) => ({
          collection:collection,
          instance:id,
          update:{
            status:updated
          }
        })
      },
      failure:{
        type:ENTITY_FAILED_TO_UPDATE
      }
    })
  }
}

export function submitCampaign(id){
  return callAPI({
    method:'POST',
    path:`/portal/v1/campaign/${id}/submit`,
    body:{},
    waitForConfirmation:true,
    begin:{
      type:ENTITY_UPDATE_REQUESTED,
      payload:(state) => {
        const user = getActiveAgencyUser(state);

        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:user.isOwner ? 'pendingAdjoy' : 'pendingAgency'
          }
        };
      }
    },
    success:{
      type:ENTITY_UPDATED,
      payload:(res,state) => {
        const user = getActiveAgencyUser(state),
          isImpersonating = getIsImpersonating(state);

        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:!isImpersonating || user.isOwner ? 'pendingAdjoy' : 'pendingAgency'
          }
        };
      }
    },
    failure:{
      type:ENTITY_FAILED_TO_UPDATE
    }
  });
}

export function rejectCampaign(id,reason){
  return callAPI({
    method:'POST',
    path:`/portal/v1/campaign/${id}/reject`,
    body:{reason:reason},
    begin:{
      type:ENTITY_UPDATE_REQUESTED,
      payload:() => {
        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:'draft',
            rejectionReason:reason
          }
        };
      }
    },
    success:{
      type:ENTITY_UPDATED,
      payload:() => {
        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:'draft',
            rejectionReason:reason
          }
        };
      }
    },
    failure:{
      type:ENTITY_FAILED_TO_UPDATE
    }
  });
}

export function adjoyRejectCampaign(id,reason){
  return callAPI({
    method:'POST',
    path:`/portal/v1/campaign/${id}/adjoyReject`,
    body:{reason:reason},
    begin:{
      type:ENTITY_UPDATE_REQUESTED,
      payload:() => {
        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:'draft',
            rejectionReason:reason
          }
        };
      }
    },
    success:{
      type:ENTITY_UPDATED,
      payload:() => {
        // const user = getActiveAgencyUser(state);

        return {
          collection:'campaigns',
          instance:id,
          update:{
            status:'draft',
            rejectionReason:reason
          }
        };
      }
    },
    failure:{
      type:ENTITY_FAILED_TO_UPDATE
    }
  });
}

//AGENCY STATUS
// export const submitCampaign = createStatusAction('campaigns','/portal/v1/campaign','submit','pendingAgency');
// export const rejectCampaign = createStatusAction('campaigns','/portal/v1/campaign','reject','draft');
export const revertCampaignToDraft = createStatusAction('campaigns','/portal/v1/campaign','revert','draft');
export const approveCampaign = createStatusAction('campaigns','/portal/v1/campaign','approve','pendingAdjoy');
export const adjoyApproveCampaign = createStatusAction('campaigns','/portal/v1/campaign','adjoyApprove','ready');
// export const adjoyRejectCampaign = createStatusAction('campaigns','/portal/v1/campaign','adjoyReject','draft');
export const suspendCampaign = createStatusAction('campaigns','/portal/v1/campaign','suspend','suspended');
export const archiveCampaign = createStatusAction('campaigns','/portal/v1/campaign','archive','archived');
export const activateCampaign = createStatusAction('campaigns','/portal/v1/campaign','activate','active');
export const requestCampaignFunds = createStatusAction('campaigns','/portal/v1/campaign','requestFunds','outOfFunds');
export const acknowledgeCampaignFunds = createStatusAction('campaigns','/portal/v1/campaign','acknowledgeFunds','active');
export const resumeCampaign = createStatusAction('campaigns','/portal/v1/campaign','resume','ready');

/*
  UPDATE ACTIONS
*/
function createUpdateAction(collection,entityPath){
  return function(id,updates){
    return callAPI({
      method:'PATCH',
      path:`${entityPath}/${id}`,
      body:updates,
      begin:{
        type:ENTITY_UPDATE_REQUESTED,
        payload:() => ({
          collection:collection,
          instance:id,
          update:updates
        })
      },
      success:{
        type:ENTITY_UPDATED,
        payload:(res) => ({
          collection:collection,
          instance:id,
          update:updates
        })
      },
      failure:{
        type:ENTITY_FAILED_TO_UPDATE
      }
    });
  }
}

export const updateAgency = createUpdateAction('agencies','/portal/v1/agency');
export const updateRetailer = createUpdateAction('companies','/portal/v1/retailer');
export const updateBrand = createUpdateAction('companies','/portal/v1/brand');
export const updateProgram = createUpdateAction('programs','/portal/v1/program');
export const updateReceiptLineup = createUpdateAction('receiptLineups','/portal/v1/rscan/lineup');
export const updatePromotion = createUpdateAction('promotions',`/portal/v1/brand/promo`);
export const updateAffiliate = createUpdateAction('affiliates','/portal/v1/affiliate');
export const updateMilestone = createUpdateAction('milestones','/portal/v1/milestone');
export const updatePromo = createUpdateAction('promos','/portal/v1/promo');
export const updateUser = createUpdateAction('users','/portal/v1/user');
export const updateProvider = createUpdateAction('users','/portal/v1/user');
export const updateCampaign = createUpdateAction('campaigns','/portal/v1/campaign');
export const updateEngagement = createUpdateAction('engagements','/portal/v1/engagement');
export const updateSegmentation = createUpdateAction('segmentations','/portal/v1/segmentation');
export const updatePromoCode = createUpdateAction('promoCodes','/portal/v1/promoCode');

export function updateAffiliateStatus(id, updates){
  return function(dispatch){
    dispatch({
      type:ENTITY_UPDATE_REQUESTED,
      payload:{
        collection:'affiliates',
        instance:id,
        update:updates
      }
    });
  }
}

/*
  LOAD ONE ACTIONS
*/
function createLoadOneAction(collection,entityPath){
  return function(id){
    return callAPI({
      path:`${entityPath}/${id}`,
      begin:{
        type:ENTITY_REQUESTED,
        payload:() => ({ collection:collection })
      },
      success:{
        type:ENTITY_LOADED,
        payload:(res) => ({
          collection:collection,
          instance:res.data,
        })
      },
      failure:{
        type:ENTITY_FAILED_TO_LOAD
      }
    });
  }
}

export const loadAgency = createLoadOneAction('agencies','/portal/v1/agency');
export const loadRetailer = createLoadOneAction('companies','/portal/v1/retailer');
export const loadBrand = createLoadOneAction('companies','/portal/v1/brand');
export const loadProgram = createLoadOneAction('programs','/portal/v1/program');
export const loadUser = createLoadOneAction('users','/portal/v1/user');
export const loadProvider = createLoadOneAction('users','/portal/v1/user');
export const loadCampaign = createLoadOneAction('campaigns','/portal/v1/campaign');
export const loadSegmentation = createLoadOneAction('segmentations','/portal/v1/segmentation');
export const loadPromoCode = createLoadOneAction('promoCodes','/portal/v1/promoCode');

/*
  CREATE ACTIONS
*/

function createCreateAction(collection,entityPath){
  return function(attributes){
    return callAPI({
      method:'POST',
      path:entityPath,
      body:attributes,
      begin:{
        type:ENTITY_CREATE_REQUESTED,
        payload:() => ({
          collection:collection,
          instance:attributes
        })
      },
      success:{
        type:ENTITY_CREATED,
        payload:(res) => ({
          collection:collection,
          instance:{
            id:res.objectId ? res.objectId : res.id,
            ...attributes
          }
        })
      },
      failure:{
        type:ENTITY_FAILED_TO_CREATE
      }
    });
  }
}

export const createUser = createCreateAction('users','/portal/v1/user');
export const createAgency = createCreateAction('agencies','/portal/v1/agency');
export const createProvider = createCreateAction('users','/sys/v1/provider');
export const createBrand = createCreateAction('companies','/portal/v1/brand');
export const createProgram = createCreateAction('companies','/portal/v1/program');
export const createReceiptLineup = createCreateAction('receiptLineups','/portal/v1/rscan/lineup');
// export const createPromotion = (brandId, attributes) => createCreateAction('promotions',`/portal/v1/brand/${brandId}/promo`) (attributes);
export const createPromotion = createCreateAction('promotions',`/portal/v1/brand/promo`);
export const createAffiliate = createCreateAction('affiliates','/portal/v1/affiliate');
export const createMilestone = createCreateAction('milestones','/portal/v1/milestone');
export const createPromo = createCreateAction('promos','/portal/v1/promo');
export const createRetailer = createCreateAction('companies','/portal/v1/retailer');
export const createEngagement = createCreateAction('engagements','/portal/v1/engagement');
export const createSegmentation = createCreateAction('segmentations','/portal/v1/segmentation');
export const createPromoCode = createCreateAction('promoCodes','/portal/v1/promoCode');
export const createAssets = (attrs) => createCreateAction('appAssets',`/portal/v1/company/${attrs.companyId}/storeRetailerAssets`)(attrs);

/*
  MISC ACTIONS
*/

export function createCampaign(attributes){
  const defaults = {
    name:'',
    active:true,
    feedText:'',
    completionText:'',
    description:'',
    useCTA:true
  };

  return callAPI({
    skipTimeout:true,
    method:'POST',
    path:'/portal/v1/campaign',
    body:{
      ...defaults,
      ...attributes
    },
    begin:{
      type:ENTITY_CREATE_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:{
          ...defaults,
          ...attributes,
          status:'draft'
        }
      })
    },
    success:{
      type:ENTITY_CREATED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id:res.objectId,
          ...defaults,
          ...attributes,
          status:'draft'
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_CREATE
    }
  });
}

export function createPaymentMethod(attributes){
  return callAPI({
    skipTimeout:false,
    method:'POST',
    path:`/portal/v1/payment/${attributes.agencyId}/token`,
    body:{
      kind:attributes.kind,
      last4:attributes.last4,
      token:attributes.token
    },
    begin:{
      type:ENTITY_CREATE_REQUESTED,
      payload:() => ({
        collection:'paymentMethods',
        instance:attributes
      })
    },
    success:{
      type:ENTITY_CREATED,
      payload:(res) => ({
        collection:'paymentMethods',
        instance:{
          id:res.objectId,
          ...attributes
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_CREATE
    }
  });
}

export function approveBrands(retailerId,brands){
  return callAPI({
    method:'POST',
    path:`/portal/v1/company/${retailerId}/approveBrands`,
    body:{
      approvedBrands:brands
    },
    begin:{
      type:ENTITY_UPDATE_REQUESTED,
      payload:() => ({
        collection:'companies',
        instance:retailerId,
        update:{
          approvedBrands:brands
        }
      })
    },
    success:{
      type:ENTITY_UPDATED,
      payload:(res) => ({
        collection:'companies',
        instance:retailerId,
        update:{
          approvedBrands:brands
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_UPDATE
    }

  })
}

export function approvePublishers(campaignId,publisherIds){}

export function unapproveBrands(retailerId,brands){
  return callAPI({
    method:'POST',
    path:`/portal/v1/company/${retailerId}/removeApprovedBrands`,
    body:{
      approvedBrands:brands
    },
    begin:{
      type:ENTITY_UPDATE_REQUESTED,
      payload:() => ({
        collection:'companies',
        instance:retailerId,
        update:{
          approvedBrands:brands
        }
      })
    },
    success:{
      type:ENTITY_UPDATED,
      payload:(res) => ({
        collection:'companies',
        instance:retailerId,
        update:{}
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_UPDATE
    }

  })
}

export function simulateRedemption(account,amount){
  return callAPI({
    method:'GET',
    path:`/sys/v1/appUser/${account}/testAdjustBalance?amount=${amount}`,
    begin:{
      type:REDEMPTION_REQUESTED,
      payload:() => ({
        loyaltyId:account,
        amount:amount
      })
    },
    success:{
      type:REDEPTION_COMPLETED,
      payload:() => ({
        loyaltyId:account,
        amount:amount
      })
    },
    failure:{
      type:REDEMPTION_FAILED
    }
  });
}

export function loadAppUser(id){
  return callAPI({
    method:'GET',
    path:`/portal/v1/appUser/${id}/report`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({
        collection:'appUsers'
      })
    },
    success:{
      type:ENTITY_LOADED,
      payload:(res) => ({
        collection:'appUsers',
        instance:{
          ...res.data.appUser,
          brands:res.data.brands,
          campaignCompletions:res.data.campaignCompletions,
          responses:res.data.responses,
          forHumans:res.data.forHumans
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD
    }
  })
}

export function deleteAgency(id){
  return callAPI({
    skipTimeout:true,
    method:'DELETE',
    path:`/portal/v1/agency/${id}`,
    begin:{
      type:ENTITY_DELETE_REQUESTED,
      payload:() => ({
        collection:'appUsers',
        instance:{
          id:id
        }
      })
    },
    success:{
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'agencies',
        instance:{
          id:id
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DELETE
    }
  })
}

export function deleteCampaign(id){
  return callAPI({
    skipTimeout:true,
    method:'DELETE',
    path:`/portal/v1/campaign/${id}`,
    begin:{
      type:ENTITY_DELETE_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:{
          id:id
        }
      })
    },
    success:{
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id:id
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DELETE
    }
  })
}

export function deleteEngagement(id){
  return callAPI({
    skipTimeout:true,
    method:'DELETE',
    path:`/portal/v1/engagement/${id}`,
    begin:{
      type:ENTITY_DELETE_REQUESTED,
      payload:() => ({
        collection:'engagements',
        instance:{
          id:id
        }
      })
    },
    success:{
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'engagements',
        instance:{
          id:id
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DELETE
    }
  })
}

export function deleteSegmentation(id){
  return callAPI({
    skipTimeout:true,
    method:'DELETE',
    path:`/portal/v1/segmentation/${id}`,
    begin:{
      type:ENTITY_DELETE_REQUESTED,
      payload:() => ({
        collection:'segmentations',
        instance:{
          id:id
        }
      })
    },
    success:{
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'segmentations',
        instance:{
          id:id
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DELETE
    }
  })
}

export function deletePaymentMethod(agencyId, paymentId) {
  return callAPI({
    method: 'DELETE',
    path: `/portal/v1/payment/${agencyId}/token/${paymentId}`,
    begin: {
      type: ENTITY_DELETE_REQUESTED,
      payload: () => ({
        collection:'paymentMethods',
        instance: { id: paymentId }
      })
    },
    success: {
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'paymentMethods',
        instance: { id: paymentId }
      })
    },
    failure: {
      type: ENTITY_FAILED_TO_DELETE
    }
  });
}

export function deletePromo(id) {
  return callAPI({
    method: 'DELETE',
    path: `/portal/v1/promo/${id}`,
    begin: {
      type: ENTITY_DELETE_REQUESTED,
      payload: () => ({
        collection:'promos',
        instance: { id: id }
      })
    },
    success: {
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'promos',
        instance: { id: id }
      })
    },
    failure: {
      type: ENTITY_FAILED_TO_DELETE
    }
  });
}

export function deletePromoCode(promoCodeId) {
  return callAPI({
    method: 'DELETE',
    path: `/portal/v1/promoCode/${promoCodeId}`,
    begin: {
      type: ENTITY_DELETE_REQUESTED,
      payload: () => ({
        collection:'promoCodes',
        instance: { id: promoCodeId }
      })
    },
    success: {
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'promoCodes',
        instance: { id: promoCodeId }
      })
    },
    failure: {
      type: ENTITY_FAILED_TO_DELETE
    }
  });
}

export function deleteAffiliate(id){
  return callAPI({
    skipTimeout:true,
    method:'DELETE',
    path:`/portal/v1/affiliate/${id}`,
    begin:{
      type:ENTITY_DELETE_REQUESTED,
      payload:() => ({
        collection:'affiliates',
        instance:{
          id:id
        }
      })
    },
    success:{
      type:ENTITY_DELETED,
      payload:(res) => ({
        collection:'affiliates',
        instance:{
          id:id
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DELETE
    }
  })
}


export function loadActiveUser(){
  return callAPI({
    path:`/portal/v1/user/me`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({ collection:'users' })
    },
    success:{
      type:ACTIVE_USER_LOADED,
      payload:(res) => ({
        collection:'users',
        instance:res.data,
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD
    }
  });
}

export function loadImpersonatedUser(){
  return callAPI({
    impersonate:true,
    path:`/portal/v1/user/me`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({ collection:'users' })
    },
    success:{
      type:IMPERSONATED_USER_LOADED,
      payload:(res) => ({
        collection:'users',
        instance:res.data,
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD
    }
  });
}

export function loadFilteredAppUsers(page,size,filter){
  return callAPI({
    impersonate:false,
    path:`/portal/v1/appUser/list?page=${page}&size=${size}&id=${filter}&loyaltyId=${filter}`,
    begin:{
      type:LIST_REQUESTED,
      payload:() => ({ collection:'appUsers' })
    },
    success:{
      type:LIST_LOADED,
      payload:(res) => ({
        collection:'appUsers',
        instances: res.data,
        hasNextPage:res.page.totalPages > page + 1,
        hasPreviousPage:page > 0
      })
    },
    failure:{
      type:LIST_FAILED_TO_LOAD
    }
  })
}

export function loadAppUsersForRetailer(id,page=0,size=100){
  return callAPI({
    impersonate:false,
    path:`/portal/v1/appUser/list?page=${page}&size=${size}&retailerId=${id}`,
    begin:{
      type:LIST_REQUESTED,
      payload:() => ({ collection:'appUsers' })
    },
    success:{
      type:LIST_LOADED,
      payload:(res) => ({
        collection:'appUsers',
        instances: res.data,
        hasNextPage:res.page.totalPages > page + 1,
        hasPreviousPage:page > 0
      })
    },
    failure:{
      type:LIST_FAILED_TO_LOAD
    }
  })
}

export function loadFilteredAppUsersForRetailer(id,page=0,size=0,filter=''){
  return callAPI({
    impersonate:false,
    path:`/portal/v1/appUser/list?page=${page}&size=${size}&idFilter=${filter}&retailerId=${id}`,
    begin:{
      type:LIST_REQUESTED,
      payload:() => ({ collection:'appUsers' })
    },
    success:{
      type:LIST_LOADED,
      payload:(res) => ({
        collection:'appUsers',
        instances: res.data,
        hasNextPage:res.page.totalPages > page + 1,
        hasPreviousPage:page > 0
      })
    },
    failure:{
      type:LIST_FAILED_TO_LOAD
    }
  })
}

export function checkIfEmailTaken(email){
  return callAPI({
    allow404:true,
    path:`/portal/v1/user/findByEmail?email=${encodeURIComponent(email)}`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({ collection:'users' })
    },
    success:{
      type:ENTITY_EXISTS,
      payload:(res) => ({
        collection:'users',
        instance:res.data || {},
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD
    }
  });
}

export function addOptionToEngagement(engagementId){
  const answerId = generateGUID();

  return callAPI({
    skipTimeout:true,
    method:'POST',
    path:`/portal/v1/engagementOption`,
    body:{
      parentId:engagementId,
      answerId:answerId,
      answer:''
    },
    begin:{
      type:ENGAGEMENT_OPTION_CREATE_REQUESTED,
      payload:() => ({
        collection:'engagementOptions',
        instance:{
          engagementId:engagementId,
          parentId:engagementId,
          answerId:answerId,
          answer:'',
          createdDate:Date.now()
        }
      })
    },
    success:{
      type:ENGAGEMENT_OPTION_CREATED,
      payload:(res) => ({
        collection:'engagementOptions',
        instance:{
          id:res.objectId,
          parentId:engagementId,
          answerId:answerId,
          answer:'',
          createdDate:Date.now()
        }
      })
    },
    failure:{
      type:ENGAGEMENT_OPTION_FAILED_TO_CREATE
    }
  });
}

export function updateEngagmentOptions(engagementId,updatedOptions){
  return callAPI({
    method:'PATCH',
    path:`/portal/v1/engagement/${engagementId}/options`,
    body:updatedOptions,
    begin:{
      type:ENGAGEMENT_OPTIONS_UPDATE_REQUESTED,
      payload:() => ({
        collection:'engagementOptions',
        instances:updatedOptions.map((o) => Object.assign({},o,{parentId:engagementId}))
      })
    },
    success:{
      type:ENGAGEMENT_OPTIONS_UPDATED,
      payload:() => ({
        collection:'engagementOptions',
        instances:updatedOptions.map((o) => Object.assign({},o,{parentId:engagementId}))
      })
    },
    failure:{
      type:ENGAGEMENT_OPTIONS_FAILED_TO_UPDATE
    }
  })
}

export function updateEngagementOption(engagementId,optionId,changes){
  return callAPI({
    method:'PATCH',
    path:`/portal/v1/engagement/${engagementId}/option/${optionId}`,
    body:changes,
    begin:{
      type:ENGAGEMENT_OPTION_UPDATE_REQUESTED,
      payload:() => ({
        collection:'engagementOptions',
        instance:{
          id:optionId,
          engagementId:engagementId,
          parentId:engagementId,
          update:changes
        }
      })
    },
    success:{
      type:ENGAGEMENT_OPTION_UPDATED,
      payload:() => ({
        collection:'engagementOptions',
        instance:{
          id:optionId,
          engagementId:engagementId,
          parentId:engagementId,
          update:changes
        }
      })
    },
    failure:{
      type:ENGAGEMENT_OPTION_FAILED_TO_UPDATE
    }
  });
}

export function deleteEngagementOption(engagementId,optionId){
  return callAPI({
    method:'DELETE',
    path:`/portal/v1/engagement/${engagementId}/option/${optionId}`,
    begin:{
      type:ENGAGEMENT_OPTION_DELETE_REQUESTED,
      payload:() => ({
        collection:'engagementOptions',
        instance:{
          id:optionId,
          parentId:engagementId
        }
      })
    },
    success:{
      type:ENGAGEMENT_OPTION_DELETED,
      payload:(res) => ({
        collection:'engagementOptions',
        instance:{
          id:optionId,
          parentId:engagementId
        }
      })
    },
    failure:{
      type:ENGAGEMENT_OPTION_FAILED_TO_DELETE
    }
  })
}

export function updateEngagementSortOrder(engagements){
  return callAPI({
    method:'PATCH',
    path:`/portal/v1/engagement/batch`,
    body:{
      engagements:engagements
    },
    begin:{
      type:ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED,
      payload:() => ({
        collection:'engagements',
        instances:engagements
      })
    },
    success:{
      type:ENGAGEMENT_SORT_ORDER_UPDATED,
      payload:() => ({
        collection:'engagements',
        instances:engagements
      })
    },
    failure:{
      type:ENGAGEMENT_SORT_ORDER_UPDATE_FAILED
    }
  })
}

export function loadLoyaltyBalance(userId){
  return callAPI({
    method:'GET',
    path:`/portal/v1/appUser/${userId}/balance`,
    begin:{
      type:LOYALTY_BALANCE_REQUESTED,
      payload:(res) => res
    },
    success:{
      type:LOYALTY_BALANCE_LOADED,
      payload:(res) => res.data.result
    },
    failure:{
      type:LOYALTY_BALANCE_FAILED_TO_LOAD,
      payload:(res) => res
    }
  });
}

export function adjustLoyaltyBalance(userId,amount){
  return callAPI({
    method:'POST',
    path:`/portal/v1/appUser/${userId}/adjust?amount=${amount}`,
    begin:{
      type:LOYALTY_BALANCE_ADJUSTMENT_REQUESTED,
      payload:(res) => res
    },
    success:{
      type:LOYALTY_BALANCE_ADJUSTED,
      payload:(res) => res
    },
    failure:{
      type:LOYALTY_BALANCE_ADJUSTMENT_FAILED,
      payload:(res) => res
    }
  });
}

export function setRetailersForBrand(brandId,retailerIds){
  return callAPI({
    method:'POST',
    path:`/portal/v1/company/${brandId}/setApprovedRetailers`,
    body:retailerIds,
    begin:{
      type:SET_APPROVED_RETAILERS_REQUESTED,
      payload:(res) => res
    },
    success:{
      type:APPROVED_RETAILERS_SET,
      payload:(res) => res
    },
    failure:{
      type:SET_APPROVED_RETAILERS_FAILED,
      payload:(res) => res
    }
  });
}

export function duplicateCampaign(campaignId){
  return callAPI({
    method:'POST',
    path:`/portal/v1/campaign/${campaignId}/duplicate`,
    begin:{
      type:ENTITY_DUPLICATE_REQUESTED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id:campaignId
        }
      })
    },
    success:{
      type:ENTITY_DUPLICATED,
      payload:(res) => ({
        collection:'campaigns',
        instance:res.data
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_DUPLICATE,
      payload:(res) => res
    }
  });
}

export function extendCampaign(campaignId, newLifetimeBudget, resumeDate, endDate){
  return callAPI({
    method:'PATCH',
    path:`/portal/v1/campaign/${campaignId}/extend`,
    body:{
      lifetimeBudget:newLifetimeBudget,
      resumeDate: resumeDate,
      endDate: endDate
    },
    begin:{
      type:ENTITY_EXTEND_REQUESTED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id: campaignId,
          lifetimeBudget: newLifetimeBudget,
          resumeDate: resumeDate,
          endDate: endDate
        }
      })
    },
    success:{
      type:ENTITY_EXTENDED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id: campaignId,
          lifetimeBudget: newLifetimeBudget,
          resumeDate: resumeDate,
          endDate: endDate
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_EXTEND,
      payload:(res) => res
    }
  });
}

export function loadAgencyWithChildren(agencyId){
  const addAgencyIdToEntity = (e) => Object.assign({},e,{agencyId:agencyId});

  return callAPI({
    path:`/portal/v1/agency/${agencyId}/withChildren`,
    begin:{
      type:ENTITY_BATCH_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_BATCH_LOADED,
      payload:(res) => ([
        {
          collection:'agencies',
          instances:[ marshalAgency(res.agency) ]
        },{
          collection:'campaigns',
          instances:(res.campaigns || []).map(marshalCampaign)
        },{
          collection:'companies',
          instances:(res.brands || []).map(marshalCompany)
        },{
          collection:'users',
          instances:(res.users || []).map(addAgencyIdToEntity).map(marshalUser)
        },{
          collection:'paymentMethods',
          instances:(res.paymentmethods || []).map(addAgencyIdToEntity).map(marshalPaymentMethod)
        }
      ])
    },
    failure:{
      type:ENTITY_BATCH_FAILED_TO_LOAD,
      payload:() => ({})
    }
  });
}

export function loadLinkInfoForUser(userId){
  return callAPI({
    path:`/sys/v1/user/${userId}/link`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_LOADED,
      payload:(res) => ({
        collection:'users',
        instance:res.data
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD,
      payload:() => ({})
    }
  })
}

export function validatePromoCode(promoCode){
  return callAPI({
    path:`/portal/v1/promoCode/validate/${promoCode}`,
    allow403:true,
    begin:{
      type:ENTITY_VALIDATION_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_VALIDATED,
      payload:(res) => {
        if(res.data){
          return Object.assign({},{valid:true},res.data);
        } else {
          return {valid:false,message:res.message};
        }
      }
    },
    failure:{
      type:ENTITY_FAILED_TO_VALIDATE,
      payload:() => ({})
    }
  })
}

export function validatePromoCodeForAgency(promoCode,agencyId){
  return callAPI({
    path:`/portal/v1/promoCode/${promoCode}/validate?agencyId=${agencyId}`,
    allow403:true,
    begin:{
      type:ENTITY_VALIDATION_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_VALIDATED,
      payload:(res) => {
        if(res.data){
          return Object.assign({},{valid:true},res.data);
        } else {
          return {valid:false,message:res.message};
        }
      }
    },
    failure:{
      type:ENTITY_FAILED_TO_VALIDATE,
      payload:() => ({})
    }
  })
}

export function loadPublishersForCampaign(campaignId){
  return callAPI({
    method:'GET',
    path:`/portal/v1/campaign/${campaignId}/publishers`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_LOADED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id:campaignId,
          publisherIds:res.data || []
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD,
      payload:() => ({})
    }
  });
}

export function updatePublishersForCampaign(campaignId,publisherIds){
  return callAPI({
    method:'POST',
    path:`/portal/v1/campaign/${campaignId}/approvePublishers`,
    body:{
      publisherIds:publisherIds
    },
    begin:{
      type:ENTITY_PUBLISHERS_UPDATE_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          publisherIds:publisherIds
        }
      })
    },
    success:{
      type:ENTITY_PUBLISHERS_UPDATED,
      payload:(res) => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          publisherIds:publisherIds
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD,
      payload:() => ({})
    }
  });
}

export function syncCampaignDCMTags(campaignId,tags){
  return callAPI({
    method:'PUT',
    path:`/portal/v1/campaign/${campaignId}/tags`,
    body:{
      tags:tags.map(marshalTag)
    },
    begin:{
      type:ENTITY_TAGS_SYNC_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        updates:{
          tags:tags
        }
      })
    },
    success:{
      type:ENTITY_TAGS_SYNCED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          tags:tags
        }
      })
    },
    failure:{
      type:ENTITY_TAGS_SYNC_FAILED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          tags:tags
        }
      })
    }
  })
}

export function syncEngagementDCMTags(engagementId,tags){
  return callAPI({
    method:'PUT',
    path:`/portal/v1/engagement/${engagementId}/tags`,
    body:{
      tags:tags.map(marshalTag)
    },
    begin:{
      type:ENTITY_TAGS_SYNC_REQUESTED,
      payload:() => ({
        collection:'engagements',
        instance:engagementId,
        update:{
          tags:tags
        }
      })
    },
    success:{
      type:ENTITY_TAGS_SYNCED,
      payload:() => ({
        collection:'engagements',
        instance:engagementId,
        update:{
          tags:tags
        }
      })
    },
    failure:{
      type:ENTITY_TAGS_SYNC_FAILED,
      payload:() => ({})
    }
  })
}

export function syncCampaignGeoFilter(campaignId,predicate,filters){
  return callAPI({
    method:'PUT',
    path:`/portal/v1/campaign/${campaignId}/geofilter`,
    body:{
      predicate:predicate,
      filters:filters
    },
    begin:{
      type:ENTITY_GEOFILTER_SYNC_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          predicate:predicate,
          filters:filters
        }
      })
    },
    success:{
      type:ENTITY_GEOFILTER_SYNCED,
      payload:(res) => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          predicate:predicate,
          filters:filters,
          reach:parseFloat(res.properties.reach)
        }
      }),
      result:(res) => {
        return parseFloat(res.properties.reach);
      }
    },
    failure:{
      type:ENTITY_GEOFILTER_SYNC_FAILED,
      payload:() => ({})
    }
  })
}

export function syncCampaignResponseFilter(campaignId,constraints){
  return callAPI({
    method:'PUT',
    path:`/portal/v1/campaign/${campaignId}/constraint`,
    body:{
      constraints:constraints
    },
    begin:{
      type:ENTITY_CONSTRAINTS_SYNC_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          constraints:constraints
        }
      })
    },
    success:{
      type:ENTITY_CONSTRAINTS_SYNCED,
      payload:(res) => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          constraints:constraints,
          reach:parseFloat(res.properties.reach)
        }
      }),
      result:(res) => {
        return parseFloat(res.properties.reach);
      }
    },
    failure:{
      type:ENTITY_CONSTRAINTS_SYNC_FAILED,
      payload:() => {}
    }
  })
}

export function targetCampaign(campaignId,targetingConfig){
  return callAPI({
    method:'PUT',
    path:`/portal/v1/campaign/${campaignId}/audience`,
    body:targetingConfig,
    begin:{
      type:ENTITY_CONSTRAINTS_SYNC_REQUESTED,
      payload:() => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          predicate:targetingConfig.predicate,
          filters:targetingConfig.filters,
          constraints:targetingConfig.constraints
        }
      })
    },
    success:{
      type:ENTITY_CONSTRAINTS_SYNCED,
      payload:(res) => ({
        collection:'campaigns',
        instance:campaignId,
        update:{
          predicate:targetingConfig.predicate,
          filters:targetingConfig.filters,
          constraints:targetingConfig.constraints,
          reach:parseFloat(res.properties.reach)
        }
      }),
      result:(res) => {
        return parseFloat(res.properties.reach);
      }
    },
    failure:{
      type:ENTITY_CONSTRAINTS_SYNC_FAILED,
      payload:() => ({})
    }
  })
}


export function loadPromoDefaults(){
  return callAPI({
    method:'GET',
    path:`/portal/v1/promo/defaults`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({ collection:'promoDefaults' })
    },
    success:{
      type:ENTITY_LOADED,
      payload:(res) => ({
        collection:'promoDefaults',
        instance:{
          id:'defaults',
          survey: res.survey,
          offer: res.offer
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD,
      payload:() => ({})
    }
  })
}

export function loadCampaignReach(campaignId){
  return callAPI({
    method:'GET',
    path:`/portal/v1/campaign/${campaignId}/reach`,
    begin:{
      type:ENTITY_REQUESTED,
      payload:() => ({ collection:'campaigns' })
    },
    success:{
      type:ENTITY_LOADED,
      payload:(res) => ({
        collection:'campaigns',
        instance:{
          id:campaignId,
          reach:parseFloat(res.data.reach)
        }
      })
    },
    failure:{
      type:ENTITY_FAILED_TO_LOAD,
      payload:() => ({})
    }
  })
}

export function loadCampaignHistory(campaignId){
  return callAPI({
    method:'GET',
    path:`/portal/v1/campaign/${campaignId}/history`,
    begin:{
      type:ENTITY_HISTORY_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:ENTITY_HISTORY_LOADED,
      payload:(res) => {
        const history = res.data
          .filter((event) => event.domain === 'campaign' && event.targetId === campaignId)
          .map((event) => ({action:event.action,timestamp:event.lastModifiedDate}))
          .sort((a,b) => a.timestamp - b.timestamp)

        return {
          collection:'campaigns',
          instance:campaignId,
          update:{
            history:history
          }
        }
      }
    },
    failure:{
      type:ENTITY_HISTORY_FAILED_TO_LOAD
    }
  })
}

export function getPreviewCampaign(previewToken) {
  return (dispatch, getState) => {
    return callAPI({
      method: 'GET',
      public: true,
      path: `/pub/v1/campaignPreview/${previewToken}`,
      begin: {
        type: NO_OP,
        payload: () => ({})
      },
      success: {
        type: NO_OP,
        payload: () => ({}),
        result: (res) => {
          console.log(res)
          return res
        }
      },
      failure: {
        type: NO_OP,
        payload: () => ({})
      }
    })(dispatch, getState)
      .then(res => {
        if (res && res.error)
          return Promise.reject(res);

        if (res && res.id) {
          const campaigns = [res]
            .filter(c => (c.engagements && c.engagements.length > 0 && c.feedItemType !== 'milestone')) // filter out empty campaigns and milestones
            .sort((a, b) => b.totalValue - a.totalValue)               // sort campaigns by value
            .map(c => ({                                              // sort engagements by ordinal
              ...c,
              brandName: c.brand.name,
              brandLogoURL: c.brand.logoURL,
              engagements: c.engagements.sort((a, b) => a.ordinal - b.ordinal)
            }));
          if (campaigns.length > 0) {
            return campaigns[0]
          }
        }
        console.log('no campaigns found for preview');
        return null;
      })
      .catch(err => {
        console.log('Failed to get campaign preview.');
        console.log(err);
        return Promise.reject(err);
      });
  }
}

export function trackSocialShare(campaignId, action, deviceId) {
  let path = deviceId ?  `/app/v1/pub/campaign/social?campaignId=${campaignId}&action=${action}&deviceId=${deviceId}`
    : `/app/v1/pub/campaign/social?campaignId=${campaignId}&action=${action}`
  console.log("trackSocialShare path = " + path)
    return callAPI({
      method: 'PATCH',
      public: true,
      path: path,
      body: {},
      begin: {
        type: NO_OP,
        payload: () => ({})
      },
      success: {
        type: NO_OP,
        payload: () => ({}),
        result: (res) => {
          console.log(res)
          return res
        }
      },
      failure: {
        type: NO_OP,
        payload: () => ({})
      }
    })
}



// WEBPACK FOOTER //
// ./src/shared/redux/entities/actions.js